import { render, staticRenderFns } from "./AddChicksNursery.vue?vue&type=template&id=0adf0ed1"
import script from "./AddChicksNursery.vue?vue&type=script&lang=js"
export * from "./AddChicksNursery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports